/** Field DOM ids used for a11y focus after validation / submit. */
export const INTAKE_FIELD_IDS: Record<
  | 'givenName'
  | 'familyName'
  | 'email'
  | 'phoneCountryIso'
  | 'phone'
  | 'currentCountryCode',
  string
> = {
  givenName: 'intake-given-name',
  familyName: 'intake-family-name',
  email: 'intake-email',
  phoneCountryIso: 'intake-phone-country',
  phone: 'intake-phone',
  currentCountryCode: 'intake-country',
};

const FOCUS_ORDER = [
  'givenName',
  'familyName',
  'email',
  'phoneCountryIso',
  'phone',
  'currentCountryCode',
] as const;

type IntakeFocusField = (typeof FOCUS_ORDER)[number];

/**
 * Focus a field within a form container (works inside Shadow DOM — do not use
 * document.getElementById from outside the shadow root).
 */
export function focusIntakeField(
  container: ParentNode | null,
  field: IntakeFocusField
): void {
  if (!container) return;
  queueMicrotask(() => {
    const el = container.querySelector(
      `#${INTAKE_FIELD_IDS[field]}`
    ) as HTMLElement | null;
    el?.focus();
  });
}

export function focusFirstIntakeError(
  container: ParentNode | null,
  errors: Partial<Record<IntakeFocusField, string>>
): void {
  const first = FOCUS_ORDER.find(f => Boolean(errors[f]));
  if (!first) return;
  focusIntakeField(container, first);
}
